import api from "../services/api";
import store from "../store";

/**
 * @returns {{user:{id:number,name:string,email:string,rest_home_id:number,rest_home_id:number,user_profile_name:string,user_group_name:string,rest_home_finance:number},permissions:{perm:{write:boolean,edit:boolean,read:boolean,remove:boolean}},rest_home_id:number,logo:string,resident_no_photo_url:string}} user e permissões
 */
export const userData = () => {
  let user = JSON.parse(sessionStorage.getItem("user"));
  let permissions = JSON.parse(sessionStorage.getItem("permissions"));
  let rest_home_id = JSON.parse(sessionStorage.getItem("rest_home_id"));
  let logo = "https://sistemclinupload.s3.amazonaws.com/3bc79a07533bb2f38f3a6704240d4de2-6763ea9adfbaf8d1f7f483560e5aea5d-LOGO.png.png"
  let resident_no_photo_url = "https://sistemclinupload.s3.amazonaws.com/resident-no-photo.png"

  return { user, permissions, rest_home_id, logo, resident_no_photo_url };
}

/**
 * faz requisição get e retorna AxiosRepsonse.data
 * @param {string} url
 * @param {boolean} throw_errors
 * @returns {{error: bool, errors: string[], any: *}}
 */
export async function getStatic(url, throw_errors) {
  let data, error, errors;

  try {
    const response = await api.get(url);
    data = response.data;
    if (!data) return { error: true, errors: ["Sem dados disponíveis"] };

    error = response.data.error;
    errors = response.data.errors;
  } catch (error) {
    console.log(error);
  }

  if (throw_errors && error) throw errors;
  else return data;
}

/**
 * @param {any[]} arr
 * @param {number} index
 * @param {number} new_index
 */
export function arraySwapItemPosition(arr, index, new_index) {
  arr[index] = arr.splice(new_index, 1, arr[index])[0];
  return arr;
}

export async function ping() {
  try {
    const response = await api.get('/status/ping', { force: true });
    if (response.status == 200) return true;
  } catch {
    return false;
  }

  return false;
}

/**
 * 
 * @param {object} self this do vue
 * @param {string} view nome da view
 */
export function restore(self, view) {
  let views = store.state.views;
  if (!views) return;
  let states = views[view];
  if (!states) return;

  const keys = Object.keys(states);
  for (const key of keys) self[key] = states[key];
}

/**
 * 
 * @param {object} self this do vue
 * @param {string} view nome da view
 * @param {string[]} attributes lista de atributos
 */
export function save(self, view, attributes) {
  let data = { view, attributes: {} };
  for (const attr of attributes) data.attributes[attr] = self[attr];
  store.commit('save', data);
}